<template>
  <div class="Legendas-tabelaalterada ml-4 mr-4">
    <b-row>
      <!-- SINTÉTICO -->
      <!-- SINTÉTICO -->
      <!-- SINTÉTICO -->
      <!-- SINTÉTICO -->
      <!-- SINTÉTICO -->
      <b-col cols="6">
        <b-form>
          <b-row>
            <!-- -->
            <!-- filial-->
            <b-col cols="5">
              <label for="input-filial">Filial</label> -- Selecionado:
              {{ filialSelecionada?.id_filial_erp }} -
              {{ filialSelecionada?.filial }}

              <div>
                <b-form-select
                  id="filial"
                  v-model="batida.id_filial_erp"
                  required
                  :options="filiais"
                  class="mb-3"
                  text-field="filial"
                  value-field="id_filial_erp"
                />
              </div>
            </b-col>

            <!--
              <b-col cols="3">
                   <label for="select-garagem">Quantidade de batidas</label> 
                <multiselect v-model="value_sptrans"  required
                :options="sptransx" 
                :multiple="true"                 
                :close-on-select="false" 
                :clear-on-select="true" 
                :p'rese'rve-search="true" placeholder="quantidade" label="status" track-by="status" name="status"
                :preselect-first="true">
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>
                </multiselect>                
              </b-col>
            -->

            <b-col cols="3">
              <div>
                <label for="datepicker-placeholder">Data do serviço</label>
                <b-form-datepicker
                  id="datepicker-placeholder"
                  v-model="data_servico"
                  required
                  placeholder="Data"
                  initial-date
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>

            <b-col>
              <br />
              <b-button
                size="sm"
                variant="primary"
                class="mr-2 mt-2"
                block
                @click="loadPontoRegistrado()"
              >
                Carregar
              </b-button>
            </b-col>
          </b-row>
        </b-form>

        <b-col>
          <div></div>
        </b-col>

        <!--    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
-->

        <!--tbl de dados -->
        <b-table
          id="sptalteracoes"
          small
          hover
          striped
          sticky-header="865px"
          :items="tabelaalteradas"
          :fields="fields"
        >
          <template slot="cell(actions)" slot-scope="data">
            <b-button
              @click="loadCarregaTabela(data.item)"
              title="Carregar atividades"
              size="sm"
              variant="primary"
              class="mr-2 mt-2"
            >
              <i class="fa fa-exclamation-circle"></i>
            </b-button>
          </template>
        </b-table>
      </b-col>

      <!--ANÁLITICO -->
      <!--ANÁLITICO -->
      <!--ANÁLITICO -->
      <!--ANÁLITICO -->
      <!--ANÁLITICO -->
      <b-col cols="6">
        <div>
          <b-row>
            <!--Almoxarife -->
            <b-col cols="1" class="mt-2">
              <b-img
                class="mb-2"
                v-model="batida.foto_url"
                :src="
                  batida.foto_url ||
                  'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/sem-foto.jpg'
                "
                rounded
                alt="-"
                style="width: 90px; height: 90px"
              ></b-img>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Registro</label>
              <b-form-input
                v-model="batida.registro"
                @keyup.enter="reset(), loadOperador(), loadLegendas()"
                required
                placeholder="RE"
              ></b-form-input>
            </b-col>

            <b-col cols="3">
              <label for="input-live">Nome </label>
              <b-input-group-text>
                {{
                  batida?.nome
                    ? batida.nome
                    : motorista?.nome
                    ? motorista.nome
                    : "-"
                }}
              </b-input-group-text>
            </b-col>

            <b-col cols="3">
              <label for="input-live">Função </label>
              <b-input-group-text>
                {{
                  batida?.funcao
                    ? batida.funcao
                    : motorista?.funcao
                    ? motorista.funcao
                    : "-"
                }}
              </b-input-group-text>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Ponto registrado</label>
              <b-input-group-text>{{
                batida.dt_gravacao
                  ? moment(batida.dt_gravacao)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-")
                  : "-"
              }}</b-input-group-text>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="6" class="mt-1">
              <label for="input-parecer">Linha</label>
              <div>
                <b-form-select
                  id="infoTipo"
                  v-model="batida.id_linha"
                  :options="linhas"
                  class="mb-3"
                  text-field="linha"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col sm="6" class="mt-1">
              <label for="input-parecer">Atividade</label>
              {{ batida.atividade_id }}
              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="batida.atividade_id"
                  :options="legendas"
                  class="mb-3"
                  text-field="legenda"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="2" class="mt-1">
              <label for="input-live">Horário</label>
              <b-form-input
                id="infoAssunto"
                v-model="batidas.horario"
                v-mask="'##:##'"
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <!--                  <LoadingModal v-if="isLoading" /> -->

            <b-col cols="2">
              <b-form-checkbox
                id="lavador"
                class="mb-3 mt-5"
                v-model="batida.cancelado"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                checked="true"
              >
                Cancelado
              </b-form-checkbox>
            </b-col>

            <b-col cols="4">
              <b-form-checkbox
                id="viradadia"
                class="mb-3 mt-5"
                v-model="batida.viradadia"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                checked="true"
              >
                Virada do dia
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="8">
              <label for="textarea-small">Observações</label>
            </b-col>
            <b-col cols="6">
              <b-form-textarea
                id="infoConteudo"
                v-model="batida.observacao"
                size="sm"
                rows="16"
                placeholder="Digite a mensagem referente ao ocorrido"
              ></b-form-textarea>
            </b-col>

            <b-col cols="6">
              <div class="pdf-container">
                <iframe
                  :src="pdfUrl ? pdfUrl : batida.arquivo"
                  width="100%"
                  height="350"
                ></iframe>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <!-- inserir o arquivo -->

            <b-col cols="12">
              <b-form-file
                v-model="file"
                @input="uploadPhoto()"
                placeholder="Selecione o arquivo"
                ref="file-input"
                class="mb-2"
              ></b-form-file>
            </b-col>

            <b-button
              v-if="marcacoes && batida.dt_cadastro"
              class="mt-3"
              variant="success"
              block
              @click="putTabelaAlteradas()"
              >Atualizar marcacoes</b-button
            >

            <!--
                  <b-col cols="2">
                    <b-button @click="file = null">Limpar arquivo</b-button>                
                  </b-col>

                  <b-col cols="3" v-if="user.id_grupo==18">                
                    <b-button  variant="warning" @click="openModal">
                      Visualizar arquivo selecionado
                    </b-button>                      
                  </b-col>
    -->
          </b-row>

          <b-row>
            <b-col cols="12">
              <p class="mt-2">
                Arquivo selecionado: <b>{{ file ? file.name : "" }}</b>
              </p></b-col
            >
            <!-- <p v-if="this.user.id_grupo == 18" class="ml-3">{{ marcacoes.marcacoes_url}}</p> -->
          </b-row>

          <!-- </form> -->
          <b-button
            class="mt-3"
            variant="success"
            block
            v-if="!batida.marcacoes_url"
            @click="putTabelaAlteradas()"
            >Gravar lançamento</b-button
          >

          <b-table
            id="batidas"
            small
            hover
            striped
            sticky-header="266px"
            :items="batidas"
            :fields="fieldsBatidas"
          >
            <template slot="cell(actions)" slot-scope="data">
              <b-button
                @click="
                  loadCarregaTabela(data.item), loadLegendas(), loadLinhas()
                "
                title="Editar marcação"
                size="sm"
                variant="primary"
                class="mr-2 mt-2"
              >
                <i class="fa fa-exclamation-circle"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import { baseApiUrl } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import VueTheMask from "vue-the-mask";
import { mapState } from "vuex";

export default {
  name: "TrafegoTabelaAlterada",

  props: {
    pdfUrl: String,
  },

  computed: {
    ...mapState(["user"]),

    filialSelecionada() {
      return this.filiais.find(
        (f) => f.id_filial_erp === this.batida.id_filial_erp
      );
    },
  },

  data: function () {
    return {
      //20/07/2024 as 21:32h
      marcacoes: [],
      motorista: [],

      //carregando: false,
      //atualizando: false,

      filiais: [],
      valor_filial: [], // [] lista
      tabelaalteradas: [], // [] lista
      tabelaalterada: {},

      batidas: [],
      batida: {},

      linhas: [],
      legendas: [],

      garagem: {},
      garagens: [], // [] lista
      sptrans: {},
      sptransx: [], // [] lista
      value_sptrans: [], // [] lista

      modalidade: {},
      modalidades: [], // [] lista
      value_modalidade: [], // [] lista

      tabelaalterada: {}, // [] lista
      data_servico: "",

      barra_inicial: 0,
      barra_limite: 300000,

      fields: [
        {
          key: "dt_servicco",
          label: "Data Operação",
          sortable: true,
          formatter: (value, key, tabelaalteradas) => {
            return moment(tabelaalteradas.dt_servico)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
        //{ key: 'qtd', label: 'Quantidade', sortable: true },
        { key: "qtd_batida", label: "Batidas", sortable: true },
        { key: "registro", label: "Registro", sortable: true },
        { key: "nome", label: "Nome", sortable: true },
        { key: "funcao", label: "Função", sortable: true },
        { key: "actions", label: "Ações" },
      ],

      fieldsBatidas: [
        {
          key: "dt_servicco",
          label: "Data Operação",
          sortable: true,
          formatter: (value, key, batidas) => {
            return moment(batidas.dt_servico)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_gravacao",
          label: "Data registrado",
          sortable: true,
          formatter: (value, key, batidas) => {
            return moment(batidas.dt_gravacao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "legenda", label: "Atividade", sortable: true },
        { key: "registro", label: "Registro", sortable: true },
        { key: "funcao", label: "Função", sortable: true },
        { key: "linha", label: "Tabela", sortable: true },
        { key: "tabela", label: "Tabela", sortable: true },
        {
          key: "cancelado",
          label: "Cancelado",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {
    Multiselect,
    VueTheMask,
  },
  methods: {
    //barra de progresso
    ready() {
      this.handle = setInterval(() => {
        this.barra_inicial = this.barra_inicial + 1000;
        if (this.barra_inicial >= this.barra_limite) {
          this.barra_inicial = 0;
          //this.loadPontoRegistrado()
        }
      }, 1000);
    },

    async loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: this.user.id_empresa, // Verifica se há empresas e junta os ids como string
        psg: this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = await `${baseApiUrl}/ctr/empresa/filial`;
      axios.get(url, { params }).then((res) => {
        this.filiais = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    loadPontoRegistrado() {
      let params = {
        empresa_id: `${this.user.id_grupo_empresa}`,
        id_filial: `${[this.valor_filial]}`,
        psg: this.user.psg,
        //    "id_modalidade": `${[this.value_modalidade.map(m => m.id_modalidade)]}`,
        //"id_status": `${[this.value_sptrans.map(s => s.id_status)]}`,
        dt_servico: `${this.data_servico}`,
      };
      const url = `${baseApiUrl}/pontoeletronico/manutencaotamarcacao`;
      axios.get(url, { params }).then((res) => {
        //this.carregando = false;

        this.tabelaalteradas = res.data.map((tabelaalterada) => {
          return { ...tabelaalterada };
        });
      });
    },

    loadPontoBatidas() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
        id_filial: `${this.user.id_filial_erp}`,
        dt_servico: `${this.data_servico}`,
        registro: `${this.batida.registro}`,
        origem: "MANUTENCAO",
      };
      const url = `${baseApiUrl}/pontoeletronico/manutencaotamarcacao`;
      axios.get(url, { params }).then((res) => {
        this.batidas = res.data.map((batida) => {
          return { ...batida };
        });
        this.loadLinhas();
        this.loadLegendas();
      });
    },

    loadLinhas() {
      let params = {
        psg: this.user.psg,
        origem: "MANUTENCAO",
        empresa_id: `${this.user.id_empresa}`,
        filial_id: `${this.user.id_filial_erp}`,
      };
      const url = `${baseApiUrl}/planejamento/linha/cad`;
      axios
        .get(url, { params })
        .then((res) => {
          this.linhas = res.data.map((lin) => {
            return { ...lin, value: lin.id_linha, linha: lin.linha }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    async loadLegendas() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial}`,
      };
      const url = await `${baseApiUrl}/planejamento/escala/legenda`;
      axios
        .get(url, { params })
        .then((res) => {
          this.legendas = res.data.map((le) => {
            return { ...le, value: le.id, legenda: le.legenda }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    async loadOperador() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.batida.registro}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/glo/escala/consulta`;
      axios.get(url, { params }).then((res) => {
        this.motorista = res.data;
      });
      this.loadPontoBatidas();
      this.loadLinhas().catch(showError);
    },

    reset() {
      this.batida["nome"] = "";
      this.batida["funcao"] = "";
      this.batida["nsr"] = "";
      this.pdfUrl = "";
    },

    async uploadPhoto() {
      if (!this.file) return;

      const formData = new FormData();
      formData.append("imagem", this.file);

      try {
        const url = `${baseApiUrl}/utils/informativo`;
        const response = await axios.post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.pdfUrl = response.data;
        console.log("Arquivo enviado com sucesso!", response.data);
      } catch (error) {
        console.error("Erro ao enviar a foto:", error);
      }
    },

    openModal() {
      // Defina a URL do PDF antes de abrir o modal
      this.pdfUrl;
      this.$bvModal.show("modal-1");
    },
    clearPdfUrl() {
      // Limpa a URL do PDF quando o modal é fechado
      this.pdfUrl = "";
    },

    loadCarregaTabela(batida) {
      this.batida = { ...batida };
      this.loadPontoBatidas();
    },

    putTabelaAlteradas() {
      let corpo = {
        psg: this.user.psg,
        id_linha: `${this.batida.id_linha}`,

        latitude: `${this.batida.latitude}`,
        longitude: `${this.batida.longitude}`,
        nsr: `${this.batida.nsr}`,
        empresa_id: `${this.user.id_empresa}`,
        id_filial: `${this.filialSelecionada?.id_filial_erp}`,
        id_funcionario: this.batida.id_funcionario
          ? `${this.batida.id_funcionario}`
          : `${this.motorista.id_funcionario}`,
        id_funcionario_cadastro: `${this.user.id_funcionario}`,
        marcacao: 0,
        id_tabela: `${this.batida.id_tabela}`,
        id_servico: `${this.batida.id_servico}`,
        dt_servico: `${this.data_servico}`,
        atividade_id: `${this.batida.atividade_id}`,
        dt_marcacao:
          this.batida.atividade_id === 31 ||
          this.batida.atividade_id === 32 ||
          this.batida.atividade_id === 33
            ? ""
            : `${
                this.data_servico + " " + this.batidas.horario + ":01.000 -0300"
              }`,
        id_partida_qh: `${this.batida.id_partida_qh}`,
        foto_url: `${this.batida.foto_url}`,
        foto_url_thumbnail: `${this.batida.foto_url_thumbnail}`,
        observacao: `${this.batida.observacao}`,
        cancelado: `${this.batida.cancelado}`,
        viradadia: `${this.batida.viradadia}`,
        arquivo: `${this.batida.arquivo ? this.batida.arquivo : this.pdfUrl}`,
        identificador_coletor: 2,
      };
      const url = `${baseApiUrl}/pontoeletronico/marcacao`;
      axios.post(url, corpo).then((res) => {
        this.$toasted.global.defaultSuccess();
        this.pdfUrl = "";
        this.tabelaalterada = res.data;
      });
    },
  },

  mounted() {
    this.loadFiliais();
    this.loadLinhas();
    this.loadLegendas();
    //this.loadSptrans()
    //    this.loadGaragens()
    //   this.loadModalidade()
    //    this.loadPontoRegistrado()
    //   this.putTabelaAlteradas()
    //    this.ready()
    // destroyed()
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.table {
  font-size: 0.8em;
  text-align: center;
}
</style>